import { render, staticRenderFns } from "./CallCenterConfirm.vue?vue&type=template&id=0ef01822&"
import script from "./CallCenterConfirm.vue?vue&type=script&lang=ts&"
export * from "./CallCenterConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports